const ServiceCard = ({ title, description, buttonText }) => {
  return (
    <div className="max-w-xs rounded overflow-hidden shadow-lg bg-white mx-2 my-4">
      <div className="px-6 py-4">
        <div className="font-bold text-xl mb-2">{title}</div>
        <p className="text-gray-700 text-base">{description}</p>
      </div>
      <div className="px-6 py-4">
        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
          {buttonText}
        </button>
      </div>
    </div>
  );};

  const Service = () => {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="container mx-auto p-6">
          <div className="flex flex-wrap justify-center">
            <ServiceCard
              title="Service 1"
              description="We offer amazing services that can help you achieve your goals."
              buttonText="Learn More"
            />
            <ServiceCard
              title="Service 2"
              description="We offer amazing services that can help you achieve your goals."
              buttonText="Learn More"
            />
            <ServiceCard
              title="Service 3"
              description="We offer amazing services that can help you achieve your goals."
              buttonText="Learn More"
            />
            <ServiceCard
              title="Service 4"
              description="We offer amazing services that can help you achieve your goals."
              buttonText="Learn More"
            />
          </div>
        </div>
      </div>
    );
  };
  
  export default Service;